import './Login.css'
import bankimg from '../imgs/finance-vector.png'
import { Link, Redirect } from 'react-router-dom'
import { useState } from 'react'

export default function Login(props) {
    const [errors, setErrors] = useState(false)
    const [redirect, setRedirect] = useState(false)

    const login = async () => {
        const queryResults = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'email': document.getElementById('login-email-input').value,
                'password': document.getElementById('login-password-input').value
            })
        })
        const queryResultJSON = await queryResults.json()
        if (queryResultJSON.logged_in === true) {
            setRedirect(true)
        }else if(queryResultJSON.logged_in==='wrong_password'){
            setErrors(true)
            document.getElementById('errors').innerHTML = 'Error: <li>Wrong Password</li>'
        }
    }

    const verifyInputs = () => {
        let errorString = ''

        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const validEmail = emailRegex.test(document.getElementById('login-email-input').value)
        if (!validEmail) {
            setErrors(true)
            errorString += '<li>Invalid E-Mail</li>'
        }

        const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/
        const validPass = passwordRegex.test(document.getElementById('login-password-input').value)
        if (!validPass) {
            setErrors(true)
            errorString += '<li>Invalid Password</li>'
        }
        document.getElementById('errors').innerHTML = 'Errors: ' + errorString
        if (validPass && validEmail) {
            setErrors(false)
            login()
        }
    }
    if (!redirect) {
        return (
            <div className='login'>
                <div className='login-left-side'>
                    <img src={bankimg} className='bank-vector-image' alt='Presonal Finance' />
                    <div className='bank-image-caption'>Finio is the most powerful tool for helping you manage your personal finance</div>
                </div>

                <div className='login-right-side'>
                    <div className='login-form-container'>
                        <div className='login-title'>Login</div>
                        <div className='login-subtitle'>
                            Welcome back! Let's get you logged in
                        </div>
                        <div id='errors' style={{ display: errors ? '' : 'none' }}></div>
                        <label htmlFor='login-email-input' className='login-label'>E-Mail</label>
                        <input type='text' id='login-email-input'></input>
                        <label htmlFor='pass-input' className='login-label'>Password</label>
                        <input type='password' id='login-password-input'></input>
                        <button id='login-submit-button'
                            onClick={() => {
                                verifyInputs()
                            }}
                        >
                            Login
                        </button>
                        <div className='login-switch'>Don't have an account? <Link to='/signup'>Sign Up</Link></div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <Redirect to='/home' />
        )
    }
}